import { getReceiptStatusLabel } from "@dune/utils";
import { Badge, getReceiptStatusBadgeVariant } from "@dune/ui";
import { ReceiptStatus } from "@dune/vars";

export const ReceiptStatusBadge = ({ status }: { status: ReceiptStatus }) => {
	const variant = getReceiptStatusBadgeVariant(status);
	const label = getReceiptStatusLabel(status);
	return <Badge variant={variant}>{label}</Badge>;
};
